/**
 * Date saisie au clavier dans le calendrier des tâches, au format suisse jour-mois-année :
 * 02.11.2026, 2.11.26, 2/11, 02112026, 021126, 0211 (année courante si absente).
 * Renvoie null si la saisie n'est pas une date réelle (31.02, 0213…).
 */
export function parseTypedDate(input: string, today: Date = new Date()): Date | null {
  const text = (input || "").trim();
  if (!text) return null;

  let parts: string[];
  if (/^\d+$/.test(text)) {
    if (text.length === 4) parts = [text.slice(0, 2), text.slice(2, 4)];
    else if (text.length === 6) parts = [text.slice(0, 2), text.slice(2, 4), text.slice(4)];
    else if (text.length === 8) parts = [text.slice(0, 2), text.slice(2, 4), text.slice(4)];
    else return null;
  } else {
    parts = text.split(/\s*[./-]\s*/).filter(Boolean);
    if (parts.length < 2 || parts.length > 3 || parts.some((p) => !/^\d+$/.test(p))) return null;
    if (parts[0].length > 2 || parts[1].length > 2 || (parts[2] && ![2, 4].includes(parts[2].length))) return null;
  }

  const day = Number(parts[0]);
  const month = Number(parts[1]);
  const year =
    parts[2] === undefined ? today.getFullYear() : parts[2].length === 2 ? 2000 + Number(parts[2]) : Number(parts[2]);

  const date = new Date(year, month - 1, day);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
  return date;
}
